const pillars = [
  { label: 'Personalized Care' },
  { label: 'Advanced Orthodontics' },
  { label: 'Children, Teens & Adults' },
  { label: 'Comfortable Experience' },
  { label: 'Virtual Consultations' },
];

export default function TrustBand() {
  return (
    <section className="bg-[#1C3528] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center divide-x divide-white/10">
          {pillars.map((p, i) => (
            <div
              key={p.label}
              className={`flex-1 flex items-center justify-center py-4 px-4 min-w-0 ${i === 0 ? 'pl-0' : ''} ${i === pillars.length - 1 ? 'pr-0' : ''}`}
            >
              <div className="flex items-center gap-2.5">
                <div className="w-1 h-1 rounded-full bg-[#C4A96E] flex-shrink-0" />
                <span
                  className="text-white/65 text-[11px] tracking-[0.12em] uppercase font-medium whitespace-nowrap"
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  {p.label}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
